import { render, staticRenderFns } from "./OrderDialogView.vue?vue&type=template&id=78d5992c"
import script from "./OrderDialogView.vue?vue&type=script&lang=js"
export * from "./OrderDialogView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports